export class Helper {
    /**
     * gets the corresponding url parameter value
     * @param sParam the url parameter name
     */
    static getUrlParameter(sParam) {
        let sPageUrl: string = window.location.search.substring(1);
        var sUrlVariables: string[] = sPageUrl.split('&');
        for (var i = 0; i < sUrlVariables.length; i++) {
            var sParameterName = sUrlVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    }

    /**
     * checks whether the jquery element is null or empty
     * @param jQueryElement the jquery element
     */
    static isNullOrEmpty(jQueryElement: JQuery<Element>): boolean {
        var res = true;

        if (jQueryElement !== null && jQueryElement[0] !== undefined && jQueryElement.length > 0) {
            res = false;
        }

        return res;
    }

    /**
     * checks whether the string is null or empty
     * @param string the string
     */
    static isStringNullOrEmpty(obj: string): boolean {
        let res: boolean = true;

        if (obj !== null && obj !== undefined && obj.toString().length > 0) {
            res = false;
        }

        return res;
    }

    /**
     * checks whether the object is null or empty
     * @param object the object
     */
    static isObjectNullOrEmpty(obj: any): boolean {
        var res = true;

        if (obj !== null && obj !== undefined) {
            res = false;
        }

        return res;
    }

    /**
     * setup click events for checkbox
     */
    static setupCheckboxClickEvent(): void {
        $('.checkbox-container .checkmark').on('click', (event: JQueryEventObject) => {
            $(event.currentTarget).next("label").trigger("click");
        })
    }

    /**
     * remove the already added validator object and reparse document
     * https://stackoverflow.com/questions/17805749/jquery-unobtrusive-custom-adapter-and-method-in-jsfiddle
     * @param formSelector the jQuery selector for the form in question
     */
    static applyCustomValidationToForm(formSelector: string): void {
        // reset validator
        $(formSelector).data('validator', null);

        // parse form data
        $.validator.unobtrusive.parse($(formSelector));
    }

    /**
     * setup custom validation 'mustbetrue'
     */
    static setupMustBeTrueValidation(): void {
        $.validator.addMethod('mustbetrue', (value: any, element: any, params: any) => {
            return element.checked;
        });

        $.validator.unobtrusive.adapters.add('mustbetrue', [], (options: any) => {
            options.rules['mustbetrue'] = {};
            options.messages['mustbetrue'] = options.message;
        });
    }

    /**
     * validate input fields on focusout event
     * @param formValidator the form validator object
     */
    static setupValidationOnFocusOut(formValidator: JQueryValidation.Validator): void {
        $('.input-and-validation-group').on('focusout', 'input', (event: JQueryEventObject) => this.validateFormFields(event, formValidator));
    }

    /**
     * validate form fields
     * @param event jQuery the event
     * @param formValidator the form validator object
     */
    static validateFormFields(event: JQueryEventObject, formValidator: JQueryValidation.Validator) {
        let currentTarget: JQuery<Element> = $(event.currentTarget);

        if (!this.isNullOrEmpty(currentTarget)) {
            if (formValidator !== undefined) {
                (<any>formValidator).element(currentTarget);
            }
        }
    }
}